import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DropDownMenuComponent } from './drop-down-menu.component'
import { DropDownServiceComponent } from './drop-down-service.component'

@NgModule({
  declarations: [DropDownMenuComponent, DropDownServiceComponent],
  imports: [CommonModule],
  exports: [DropDownMenuComponent, DropDownServiceComponent],
})
export class ComponentsModule {}
